import { render } from "./TopMenuItems.vue?vue&type=template&id=7dfe1512"
import script from "./TopMenuItems.vue?vue&type=script&lang=js"
export * from "./TopMenuItems.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__